import { render, staticRenderFns } from "./UiPaginator.vue?vue&type=template&id=154dc377&"
import script from "./UiPaginator.vue?vue&type=script&lang=js&"
export * from "./UiPaginator.vue?vue&type=script&lang=js&"
import style0 from "./UiPaginator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports